<div class="form-subcontainer">
    <div class="form-content">
        <!-- <div class="form-header">
            <button clickable="" class="btn-close"><svg xmlns="http://www.w3.org/2000/svg" width="17.657"
                    height="17.657" viewBox="0 0 17.657 17.657">
                    <g _ngcontent-kcr-c822="" id="Group_12987" data-name="Group 12987"
                        transform="translate(-5669.475 -484.975)">
                        <line _ngcontent-kcr-c822="" id="Line_325" data-name="Line 325" x2="12" y2="12"
                            transform="translate(5672.304 487.804)" fill="none" stroke="#bebfbe" stroke-linecap="round"
                            stroke-width="4"></line>
                        <line _ngcontent-kcr-c822="" id="Line_326" data-name="Line 326" x1="12" y2="12"
                            transform="translate(5672.304 487.804)" fill="none" stroke="#bebfbe" stroke-linecap="round"
                            stroke-width="4"></line>
                    </g>
                </svg></button>
            <h2 class="form-title">Security Tips</h2>
        </div> -->
        <div>

            <form class="fpx-form-group">
                <section class="security-tips-container">
                    <h4 class="heading">{{'SECURITYTIPS.heading' | translate}}</h4>
                    <p >{{'SECURITYTIPS.data' | translate}}</p>

                    <details>
                        <summary><span class="summary-title">{{'SECURITYTIPS.subheading' | translate}}</span>
                            <div class="summary-chevron-up">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-chevron-down">
                                    <polyline points="6 9 12 15 18 9"></polyline>
                                </svg>
                            </div>
                        </summary>
                        <div class="active">
                       
                                <!-- <div innerHTML="{{'SECURITYTIPS.sdata' | translate}}"></div>  -->
                                <div innerHTML="{{'SECURITYTIPS.sdata1' | translate}}"></div> 
                       
                        
                        <!-- <p innerHTML="{{'SECURITYTIPS.sdata2' | translate}}"></p>
                        <p innerHTML="{{'SECURITYTIPS.sdata3' | translate}}" > </p>
                        <p innerHTML="{{'SECURITYTIPS.sdata4' | translate}}"> </p>
                        <p innerHTML="{{'SECURITYTIPS.sdata5' | translate}}"> </p> -->
                        </div>
                        
                        <div class="summary-chevron-down">
                            <svg xmlns="http://www. w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-chevron-up">
                                <polyline points="18 15 12 9 6 15"></polyline>
                            </svg>
                        </div>
                    </details>
                    <details>
                        <summary><span class="summary-title">{{'SECURITYTIPS.subheading1' | translate}}</span>
                            <div class="summary-chevron-up">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-chevron-down">
                                    <polyline points="6 9 12 15 18 9"></polyline>
                                </svg>
                            </div>
                        </summary>
                        <div class="active">
                         
                                <div innerHTML="{{'SECURITYTIPS.sdata6' | translate}}"></div>
                         
                        
                        <!-- <p innerHTML="{{'SECURITYTIPS.sdata7' | translate}}"></p>
                        <p innerHTML="{{'SECURITYTIPS.sdata8' | translate}}"></p>
                        <p  innerHTML="{{'SECURITYTIPS.sdata9' | translate}}"></p> -->
                        <!-- <p innerHTML="{{'SECURITYTIPS.sdata10' | translate}}"></p>
                        <p innerHTML="{{'SECURITYTIPS.sdata11' | translate}}"></p>
                        <p innerHTML="{{'SECURITYTIPS.sdata12' | translate}}"></p> -->
                        </div>
                        <div class="summary-chevron-down">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-chevron-up">
                                <polyline points="18 15 12 9 6 15"></polyline>
                            </svg>
                        </div>
                    </details>
                    <details>
                        <summary><span class="summary-title">{{'SECURITYTIPS.subheading2' | translate}}</span>
                            <div class="summary-chevron-up">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="feather feather-chevron-down">
                                    <polyline points="6 9 12 15 18 9"></polyline>
                                </svg>
                            </div>
                        </summary>
                        <div class="active">
                         <div innerHTML="{{'SECURITYTIPS.sdata13' | translate}}"></div>
                        <!-- <p innerHTML="{{'SECURITYTIPS.sdata14' | translate}}"></p> -->
                       </div>
                        <div class="summary-chevron-down">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-chevron-up">
                                <polyline points="18 15 12 9 6 15"></polyline>
                            </svg>
                        </div>
                    </details>
                 </section>
            </form>
        </div>
    </div>
</div>